<script setup lang="ts">
import { computed, PropType } from 'vue'
import { $date } from '@/plugins'
import { type TicketStateType, TicketStateEnum } from '@/types/sword-desk/tickets/ticket.types'
import { capitalize } from '@/utils/filters'

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  updatedAt: {
    type: String,
    required: true,
  },
  state: {
    type: String as PropType<TicketStateType>,
    required: true,
  },
  link: {
    type: String,
    required: true,
  },
})

const tagColor = computed(() => {
  switch (props.state) {
    case TicketStateEnum.PENDING:
      return 'yellow'
    case TicketStateEnum.CLOSED:
    case TicketStateEnum.SOLVED:
      return 'green'
    case TicketStateEnum['ON HOLD']:
    case TicketStateEnum.HIDDEN:
      return 'grey'
    case TicketStateEnum.NEW:
    case TicketStateEnum.OPEN:
    default:
      return 'blue'
  }
})

</script>

<template>
  <li class="select-none hover:bg-primary-100">
    <a
      class="flex justify-between gap-2 py-4 !text-grey-900"
      target="_blank"
      :href="link"
    >
      <div class="flex shrink grow flex-col gap-1.5 truncate">
        <div class="flex items-center gap-2">
          <div v-tooltip="title" class="w-full max-w-max shrink grow truncate text-t3 font-semibold">{{ title }} </div>
          <sword-icon name="external-link" class="!size-4 !fill-grey-600 !align-text-top" />
        </div>

        <div class="text-t4 font-medium text-grey-600">
          {{ $t('COMMON.UPDATED') }}: {{ $date().howLongAgo(updatedAt) }}
        </div>
      </div>

      <sword-tag
        :color="tagColor"
        class="!pointer-events-none"
        size="sm"
      >
        {{ capitalize(state) }}
      </sword-tag>
    </a>
  </li>
</template>
